module.exports = __webpack_public_path__ + "img/saihokonft.091b71ec.png";